import { absolutePath } from "../../absolutePath";

export const connections = {
  metrics: () => absolutePath(`admin/connections/metrics`),
  topConnectors: (limit?: number) =>
    absolutePath(`admin/connections/top_connectors`, limit ? { limit } : {}),
  latestConnections: (page?: number, per_page?: number) =>
    absolutePath(`admin/connections/latest_connections`, {
      ...(page && { page }),
      ...(per_page && { per_page }),
    }),
};
